var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.153 0H14.2097H9.88228H8.78178C7.7616 0 6.83702 0.60124 6.42302 1.53321L0.0953807 15.7804C-0.225878 16.5031 0.303816 17.3175 1.09453 17.3175H7.81992L3.57855 29.5382C3.05363 31.0504 5.1007 32.0866 6.00902 30.7684L18.2885 12.9558C18.7064 12.3498 18.2732 11.5249 17.537 11.5239L10.7418 11.5173L12.8157 6.88416C13.0729 6.31064 13.6427 5.94168 14.2709 5.94168H17.9376C18.5792 5.94168 19.1605 5.56315 19.4206 4.97721L21.0307 1.34777C21.3118 0.713078 20.8471 0 20.153 0Z",
    fill: "#8657F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.040ddc4524501fad270913fa207c2351.svg";
export { ForwardRef as ReactComponent };